package com.essntl.features.dashboard.ui

import com.essntl.features.request.domain.model.RequestModel
import com.essntl.features.task.domain.model.TaskModel

interface DashboardEvent {
    data object LoadItems : DashboardEvent
    data class UpdateRequest(val request: RequestModel) : DashboardEvent
    data class UpdateRequestStatus(
        val requestId: String,
        val status: RequestModel.Status,
    ) : DashboardEvent

    data object SwitchItineraries : DashboardEvent
    data object SwitchProposals : DashboardEvent
    data class UpdateTask(val task: TaskModel) : DashboardEvent
    data class UpdateTaskStatus(
        val taskId: String,
        val status: TaskModel.Status,
    ) : DashboardEvent

    data object LoadTasks : DashboardEvent
}